"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.synthesizeObject = void 0;
var synthesizeValue_1 = require("./synthesizeValue");
function synthesizeObject(schema, options) {
    var _a;
    var random = options.random;
    var object = {};
    Object.entries((_a = schema.properties) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
        var _b = __read(_a, 2), propertyName = _b[0], propertySchema = _b[1];
        var required = schema.required ? schema.required.includes(propertyName) : false;
        if (required) {
            object[propertyName] = (0, synthesizeValue_1.synthesizeValue)(propertySchema, options);
        }
        else if (random() < 0.5) {
            object[propertyName] = (0, synthesizeValue_1.synthesizeValue)(propertySchema, options);
        }
    });
    return object;
}
exports.synthesizeObject = synthesizeObject;
